import i18next from "i18next";

export enum WinningType {
  REGULAR = "REGULAR",
  SPARE = "SPARE",
  INSTANCE = "INSTANCE",
  TARDY = "TARDY",
}

export function winnerTypeToString(type: WinningType | undefined | null) {
  if (type === WinningType.REGULAR) {
    return i18next.t("userdetail_userinfo_regular");
  } else if (type === WinningType.SPARE) {
    return i18next.t("userdetail_userinfo_standby");
  }
  return "";
}
